import NewCairoHeroImage from "./new-cairo-hero-image/NewCairoHeroImage";

export default function HeroImage() {
  return <NewCairoHeroImage />;
}